import styles from './Logo.scss';
import { Component } from 'react';
import { Link } from 'react-router';

class Header extends Component {

    render(){
        return (
            <Link className={styles.logo} title="Complion" to={this.props.route} data-cy="ActionCenter-logo"></Link>
        );
    }
}
export default Header;
